import {
  guardAction,
  guardLoader,
  orderAheadManageGate,
} from "../../order-ahead/guards";
import {
  ActionFunctionArgs,
  Outlet,
  redirect,
  useLocation,
  useNavigate,
} from "react-router-dom";
import toast from "react-hot-toast";
import { Breadcrumb } from "../../../components/Breadcrumb";
import {
  OrderAheadItemEdit,
  orderAheadItemEditLoader, orderAheadItemEditAction
} from "./OrderAheadItemEdit";
import { Item } from "../../../types/item";
import {
  OrderAheadItemCreate,
  orderAheadItemCreateLoader, orderAheadItemCreateAction
} from "./OrderAheadItemCreate";
import { createApolloClient } from "../../../providers/ApolloClientFactory";
import {DELETE_ORDER_AHEAD_ITEM} from "./mutations";
import {
  OrderAheadItemClone,
  orderAheadItemCloneAction, orderAheadItemCloneLoader,
} from "./OrderAheadItemClone";

const client = createApolloClient();

const OrderAheadItemIndex = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/order-ahead-items") {
    navigate(`/order-ahead/overview`);
  }

  return (
    <>
      <Outlet />
    </>
  );
};

const orderAheadItemDeleteAction = async ({ params }: ActionFunctionArgs) => {
  const { id } = params;
  try {
    await client.mutate({
      mutation: DELETE_ORDER_AHEAD_ITEM,
      variables: { id },
    });
    toast.success("Order Ahead Item Deleted");
    return redirect(`/order-ahead/overview`);
  } catch {
    toast.error("Failed to delete Order Ahead Item");
    return null;
  }
};

export const orderAheadItemsRouter = {
  path: "/order-ahead-items",
  id: "order-ahead-items",
  // Every route under here creates or changes data.
  loader: guardLoader(orderAheadManageGate),
  element: <OrderAheadItemIndex />,
  handle: {
    crumb: () => <Breadcrumb name="Order Ahead Items" href="/order-ahead/overview" />,
  },
  children: [
    {
      path: "create",
      id: "order-ahead-items-create",
      element: <OrderAheadItemCreate />,
      action: guardAction(orderAheadManageGate, orderAheadItemCreateAction),
      loader: guardLoader(orderAheadManageGate, orderAheadItemCreateLoader),
      handle: {
        crumb: () => <Breadcrumb name={`Create Order Ahead Item`} href={`/order-ahead-items/create`} />,
      },
    },
    {
      path: ":id/edit",
      id: "order-ahead-items-edit",
      element: <OrderAheadItemEdit />,
      loader: guardLoader(orderAheadManageGate, orderAheadItemEditLoader),
      action: guardAction(orderAheadManageGate, orderAheadItemEditAction),
      handle: {
        crumb: (data: Item) => (
          <Breadcrumb
            name={`Edit ${data.name}`}
            href={`/order-ahead-items/${data.id}/edit`}
          />
        ),
      },
    },
    {
      path: ":id/clone",
      id: "order-ahead-items-clone",
      element: <OrderAheadItemClone />,
      action: guardAction(orderAheadManageGate, orderAheadItemCloneAction),
      loader: guardLoader(orderAheadManageGate, orderAheadItemCloneLoader),
    },
    {
      path: ":id/delete",
      id: "order-ahead-items-delete",
      action: guardAction(orderAheadManageGate, orderAheadItemDeleteAction),
    },
  ],
};
